import { render } from "./BxsTextareaField.vue?vue&type=template&id=74765fac&scoped=true"
import script from "./BxsTextareaField.vue?vue&type=script&lang=js"
export * from "./BxsTextareaField.vue?vue&type=script&lang=js"

import "./BxsTextareaField.vue?vue&type=style&index=0&id=74765fac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74765fac"]])

export default __exports__